import React from 'react';
import { BasicContainer, FlexRow, BodyText } from '@minecraft.atoms';

export interface StatusIndicatorProps {
  label: string;
  color?: 'inactive' | 'active';
}

export const StatusIndicator = ({ label, color = 'inactive' }: StatusIndicatorProps) => {
  return (
    <FlexRow
      alignItems="center"
      bgColor={color === 'active' ? 'successDisabled' : 'disabled'}
      borderRadius="lg"
      className="cn_atom_px-2 cn_atom_py-2"
      gap="2"
      grow={0}
      justifyContent="center"
      w="fit"
      wrap="nowrap"
      data-testid="status-indicator-wrapper"
    >
      <BasicContainer
        borderRadius="full"
        bgColor={color === 'active' ? 'successActive' : 'cardHighContrast'}
        minWidth={0.625}
        minHeight={0.625}
        data-testid="styled-circle"
      />
      <BodyText fontWeight="bold" color={color === 'active' ? 'success' : 'disabled'} lineHeight="ultraCondensed">
        {label}
      </BodyText>
    </FlexRow>
  );
};
